import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
type Buyer = {
  name: string;
  country: string;
  city: string;
};
const BUYERS: Buyer[] = [{
  name: 'Dr. Andrés Restrepo',
  country: 'Colombia',
  city: 'Medellín'
}, {
  name: 'Dra. Lucía Fernández',
  country: 'España',
  city: 'Valencia'
}, {
  name: 'Dr. Manuel Ortega',
  country: 'México',
  city: 'Guadalajara'
}, {
  name: 'Dra. Valeria Sosa',
  country: 'Argentina',
  city: 'Córdoba'
}, {
  name: 'Dr. Rodrigo Cáceres',
  country: 'Chile',
  city: 'Santiago'
}, {
  name: 'Dra. Camila Prado',
  country: 'Perú',
  city: 'Lima'
}, {
  name: 'Dr. Esteban Molina',
  country: 'Costa Rica',
  city: 'San José'
}, {
  name: 'Dra. Mariana Duarte',
  country: 'Uruguay',
  city: 'Montevideo'
}, {
  name: 'Dr. Julio Navarrete',
  country: 'Ecuador',
  city: 'Quito'
}, {
  name: 'Dra. Silvia Aguilar',
  country: 'Guatemala',
  city: 'Ciudad de Guatemala'
}, {
  name: 'Dr. Fabián Ríos',
  country: 'Panamá',
  city: 'Panamá'
}, {
  name: 'Dra. Rocío Benítez',
  country: 'Paraguay',
  city: 'Asunción'
}];
const MINUTES = ['hace 2 minutos', 'hace 4 minutos', 'hace 7 minutos', 'hace 11 minutos'];
export function PurchaseProofPopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimeout: number;
    let hideTimeout: number;
    const cycle = () => {
      showTimeout = window.setTimeout(() => {
        setVisible(true);
        hideTimeout = window.setTimeout(() => {
          setVisible(false);
          setIndex(prev => (prev + 1) % BUYERS.length);
          cycle();
        }, 5200);
      }, 9000);
    };

    // First appearance a bit sooner.
    showTimeout = window.setTimeout(() => {
      setVisible(true);
      hideTimeout = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % BUYERS.length);
        cycle();
      }, 5200);
    }, 4500);
    return () => {
      window.clearTimeout(showTimeout);
      window.clearTimeout(hideTimeout);
    };
  }, [dismissed]);
  const buyer = BUYERS[index];
  const minutes = MINUTES[index % MINUTES.length];
  return <AnimatePresence data-id="element-178" data-mp="3l8npx3tvwx70">
      {visible && !dismissed ? <motion.div initial={{
      x: -24,
      y: 16,
      opacity: 0
    }} animate={{
      x: 0,
      y: 0,
      opacity: 1
    }} exit={{
      x: -24,
      opacity: 0
    }} transition={{
      duration: 0.35,
      ease: 'easeOut'
    }} className="fixed bottom-24 left-3 z-30 w-[min(19rem,calc(100vw-1.5rem))] sm:bottom-6 sm:left-6" role="status" aria-live="polite" data-id="element-179" data-mp="3q2ig8q3zwaf2">
          <div className="relative flex items-start gap-3 rounded-2xl border border-cream-200 bg-white p-3 pr-8 shadow-xl" data-id="element-180" data-mp="cv8d1m8au694">
            <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-50" data-id="element-181" data-mp="2am1hoyuecuet">
              <CheckCircle2Icon className="h-5 w-5 text-emerald-600" aria-hidden="true" data-id="element-182" data-mp="2emlfm4mso220" />
            </div>
            <div className="min-w-0" data-id="element-183" data-mp="274vno5bokkgb">
              <p className="text-[13px] font-bold leading-snug text-navy-900" data-id="element-184" data-mp="22bkf9zr7zvma">
                {buyer.name}
              </p>
              <p className="text-[12px] leading-snug text-navy-800/75" data-id="element-185" data-mp="1xe0xwqz872q4">
                compró el <span className="font-semibold" data-id="element-186" data-mp="1tc73h0fmiuye">Sistema Maestro de TRT™</span>
              </p>
              <p className="mt-0.5 text-[11px] font-medium text-navy-800/55" data-id="element-187" data-mp="2q26jffy3svr0">
                {buyer.city}, {buyer.country} · {minutes}
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="absolute right-1.5 top-1.5 rounded-full p-1 text-navy-800/40 transition-colors hover:bg-cream-100 hover:text-navy-800" data-id="element-188" data-mp="2h0yon7usqd1o">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-189" data-mp="15jgw74io0zug" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}